<template>
  <span class="d-flex input-group" id="sensitive-field">
    <input ref="sensitive-input" :readonly="readonly" :type="fieldType" class="form-control" v-model="text">
    <button @click="switchFieldType" class="btn btn-outline-primary" type="button">{{buttonText}}</button>
  </span>
</template>

<script>
  export default {
    props: {
      text: {
        type: String,
        required: true
      },
      readonly: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        fieldType: 'password',
        buttonText: 'Show'
      }
    },
    methods: {
      switchFieldType() {
        if (this.fieldType === 'password') {
          this.fieldType = 'text'
          this.buttonText = 'Hide'
        } else {
          this.fieldType = 'password'
          this.buttonText = 'Show'
        }
      },
      selectText() {
        const sensitiveInput = this.$refs['sensitive-input']
        sensitiveInput.focus()
        sensitiveInput.select()
      }
    }
  }

</script>

<style scoped>
  input {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
</style>
